import {useEffect, useState} from "react";
import {IconButton} from "@mui/material";
import {FiTrash2} from "react-icons/fi";
import {tokenColumns} from "../../constants/dataGridColumns";
import ListView from "../ListView/ListView";
import useApiRequest from "../../hooks/useApiRequest";
import useConfirmDialog from "../../hooks/useConfirmDialog";
import ConfirmDialog from "../ui/ConfirmDialog";
import {DEFAULT_PAGINATION} from "../../utils/pagination";

const UserTokensGrid = ({userId}) => {
  const {data, loading, list} = useApiRequest({baseUrl: `/tokens?userId=${userId}`, resource: "tokens"});
  const {remove} = useApiRequest({baseUrl: "/tokens", resource: "tokens"});

  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
    } catch (error) {
      console.error("Error al eliminar el token:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await list({page: paginationModel.page, limit: paginationModel.pageSize});
      } catch (error) {
        console.error("Error al cargar los tokens:", error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [paginationModel, setPaginationModel] = useState(DEFAULT_PAGINATION);

  useEffect(() => {
    (async () => {
      try {
        await list({page: paginationModel.page, limit: paginationModel.pageSize});
      } catch (error) {
        console.error("Error al cargar los tokens:", error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationModel]);

  const handleOpenDeleteDialog = (id) => {
    const tokenList = Array.isArray(data?.data) ? data.data : [];
    const found = tokenList.find((token) => token.id === id);
    openDialog(id, found?.token || "");
  };

  const columns = [
    ...tokenColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenDeleteDialog(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <ListView
        columns={columns}
        data={data?.data || []}
        getRowId={(row) => row.id}
        loading={loading}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
      />
      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="token"
        entityLabel={itemName}
      />
    </>
  );
};

export default UserTokensGrid;
